var interjections = ["Aha", "Boo-yah", "Ho-ho", "Hurrah ", "Olé", "Rah", "Ta-da", "Bazinga!"];
module.exports = interjections;